const scriptForm = {
  bindings: {
    emulist: '<',
    fleetlist: '<',
    trainlist: '<',
    eventlist: '<',
    carlist: '<',
  },
  templateUrl: '/modules/psa/script-form/script-form.html',
  controller: 'ScriptFormController',
};

angular
  .module('psa.module')
  .component('scriptForm', scriptForm);
